import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  ActivePassiveIncomeCard,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/IncomeAttestation/ActivePassiveIncomeCard';
import { RadioGroupInput } from 'Packages/FacetDesign/Components/RadioGroupInput';

export const IncomeAttestationOverride = buildFacetDesignOverride()
  .nameOverride(['earnedIncome', 'passiveIncome'], {
    _component: () => ActivePassiveIncomeCard,
  }, overrideReadOnly)
  .nameOverride(['attestsHighEarnedIncome', 'attestsFutureHighEarnedIncome'], {
    _component: () => RadioGroupInput,
    _customProps: {
      direction: 'row',
    },
  }, overrideReadOnly);
